import { SnapshotLabelHtmlClassNames } from "@/animation/video-generator";
import { ToolLoadingStateProvider } from "@/grid/ToolLoadingStateContext";
import { useAppDispatch } from "@/reducer";
import { addCountryPlot, useCountryPlot } from "@/reducer/CountryPlotState";
import type { CountryPlotType } from "@/reducer/client-models/CountryPlot";
import { classNames } from "@/utility/jsx";
import type { GridCellLayout } from "@mm/metx-workbench.meteomatics.com";
import { Suspense, lazy, memo, useEffect } from "react";

export type GridCountryPlotProps = {
  countryPlot: CountryPlotType;
  cellLayout: GridCellLayout;
};

export const CountryPlotViewLazy = memo(
  lazy(() =>
    import("@/countryPlotView/CountryPlotView")
      .then(({ CountryPlotView }) => ({ default: CountryPlotView }))
      .catch((e) => {
        console.error(e);
        return { default: () => <div>Loading Country Plot View failed</div> };
      }),
  ),
);
const CountryPlotOverlay = memo(
  lazy(() =>
    import("@/overlay/overlays/default/CountryPlotOverlay")
      .then(({ CountryPlotOverlay }) => ({ default: CountryPlotOverlay }))
      .catch(() => {
        console.error("error");
        return { default: () => <div>Loading Country Plot View failed</div> };
      }),
  ),
);

export function GridCountryPlot({ countryPlot, cellLayout }: GridCountryPlotProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(addCountryPlot(countryPlot));
  }, [dispatch, countryPlot]);

  const countryPlotFromRedux = useCountryPlot(countryPlot.id);

  if (!countryPlotFromRedux) {
    return null;
  }

  return (
    <ToolLoadingStateProvider>
      <div className="overlay">
        <div className="overlay__layer">
          <Suspense fallback={<mm-loader size="large" />}>
            <CountryPlotViewLazy countryPlot={countryPlotFromRedux} />
          </Suspense>
        </div>
        <div className={classNames("overlay__layer", "gui-overlay", SnapshotLabelHtmlClassNames.CountryPlot)}>
          <Suspense fallback={null}>
            <CountryPlotOverlay plot={countryPlot} cellLayout={cellLayout} />
          </Suspense>
        </div>
      </div>
    </ToolLoadingStateProvider>
  );
}
